import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CalculationPage } from '@/areas/calculations/ProjectCalculation/CalculationPage';
import { calculationViewModulePermissions, canViewCalculation } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/calculation/')({
    staticData: {
        access: { permissions: canViewCalculation, modulePermissions: calculationViewModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <CalculationPage {...pathParams} />;
}
